// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"95":"cf4bf055","324":"2b395943","342":"926f0edd","448":"035f7bba","533":"7afc066b","793":"bb3b48ee"}[chunkId] + ".css";
};